import { TerminEntry } from '@/domain/termine/features/Calendar/Grid/Termin/TerminEntry';
import { DayPopover } from '@/domain/termine/features/Calendar/Grid/DayCell/Popover/DayPopover';
import { Termin } from '@/domain/termine/shared/types/Termin';
import dayjs from 'dayjs';
import { FeiertagEntry } from '@/domain/termine/features/Calendar/Grid/Feiertag/FeiertagEntry';

interface DayCellTabletEntriesProps {
  visible: Termin[];
  hidden: Termin[];
  day: dayjs.Dayjs;
  stopCellClickPropagation?: boolean;
}

export function DayCellTabletEntries({
  visible,
  hidden,
  day,
}: DayCellTabletEntriesProps) {
  return (
    <div className="flex-col md:flex hidden lg:hidden">
      <div className="pt-1">
        <FeiertagEntry day={day} />
      </div>
      {visible.map((termin) => (
        <div
          key={termin.id}
          onClick={(e) => e.stopPropagation()}
          className="cursor-pointer">
          <TerminEntry
            key={termin.id}
            termine={[termin]}
            className="bg-neutrals-N200"
          />
        </div>
      ))}
      {hidden.length > 0 && <DayPopover termine={hidden} day={day} />}
    </div>
  );
}
